import React, { useEffect, useState } from 'react';
// Styles provided by RestaurantOnboarding.css

/* ── Confetti data (determinístico, sin Math.random) ── */
const COLORS = ['#F97316','#10B981','#3B82F6','#F59E0B','#EC4899','#8B5CF6','#EF4444','#06B6D4'];
const CONFETTI = Array.from({ length: 38 }, (_, i) => ({
  id: i,
  color: COLORS[i % COLORS.length],
  x: `${2 + (i * 6.8) % 95}%`,
  delay: `${(i * 0.055) % 1.6}s`,
  dur: `${1.4 + (i * 0.085) % 1.1}s`,
  width: `${7 + (i * 4) % 10}px`,
  height: `${5 + (i * 3) % 8}px`,
  rot0: (i * 53) % 360,
  rot1: (i * 53 + 270 + i * 31) % 720,
  circle: i % 4 === 0,
}));

/* ── Emojis flotantes ── */
const EMOJIS = [
  { e: '🎉', delay: '0.9s',  dur: '2.8s', left: '8%',  top: '18%' },
  { e: '🥳', delay: '1.1s',  dur: '3.2s', left: '85%', top: '22%' },
  { e: '⭐', delay: '1.3s',  dur: '2.6s', left: '15%', top: '60%' },
  { e: '🚀', delay: '1.5s',  dur: '3.0s', left: '80%', top: '55%' },
  { e: '✨', delay: '0.7s',  dur: '2.4s', left: '50%', top: '75%' },
  { e: '🎊', delay: '1.7s',  dur: '3.4s', left: '78%', top: '15%' },
];

const StepRestaurantSuccess = ({ onReset }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // pequeño delay para que el slide-in termine antes de la celebración
    const t = setTimeout(() => setShow(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`ro-success-page${show ? ' ro-success-page--in' : ''}`}>

      {/* ── Confetti ── */}
      <div className="ro-confetti-stage" aria-hidden="true">
        {CONFETTI.map((c) => (
          <span
            key={c.id}
            className={`ro-confetti-piece${c.circle ? ' ro-confetti-piece--circle' : ''}`}
            style={{
              left: c.x,
              width: c.width,
              height: c.height,
              background: c.color,
              '--delay': c.delay,
              '--dur':   c.dur,
              '--rot0':  `${c.rot0}deg`,
              '--rot1':  `${c.rot1}deg`,
            }}
          />
        ))}
      </div>

      {/* ── Emojis flotantes ── */}
      <div className="ro-success-emojis" aria-hidden="true">
        {EMOJIS.map((em, i) => (
          <span
            key={i}
            className="ro-success-emoji"
            style={{
              left: em.left,
              top: em.top,
              '--delay': em.delay,
              '--dur':   em.dur,
            }}
          >
            {em.e}
          </span>
        ))}
      </div>

      {/* ── Contenido central ── */}
      <div className="ro-success-body">

        {/* Checkmark SVG animado */}
        <div className="ro-success-check-wrap">
          <svg className="ro-success-svg" viewBox="0 0 100 100" fill="none" aria-hidden="true">
            {/* Halo pulsante */}
            <circle cx="50" cy="50" r="48" className="ro-success-halo" />
            {/* Círculo que se dibuja */}
            <circle
              cx="50" cy="50" r="42"
              stroke="#10B981"
              strokeWidth="5"
              strokeLinecap="round"
              className="ro-success-circle"
            />
            {/* Check que se dibuja */}
            <polyline
              points="28,51 43,66 72,36"
              stroke="#10B981"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="ro-success-tick"
            />
          </svg>
        </div>

        {/* Título con bounce */}
        <h1 className="ro-success-title">¡Felicitaciones!</h1>
        <p className="ro-success-sub">Tu negocio ya está en revisión</p>

        {/* Tarjeta de info */}
        <div className="ro-success-card">
          <div className="ro-success-card-row">
            <span className="ro-success-card-ico">📋</span>
            <div>
              <strong>Revisión en proceso</strong>
              <p>Nuestro equipo revisará la información de tu negocio en las próximas <strong>24–48 horas</strong></p>
            </div>
          </div>
          <div className="ro-success-card-row">
            <span className="ro-success-card-ico">📧</span>
            <div>
              <strong>Te avisaremos por correo</strong>
              <p>Recibirás un email con el resultado de la revisión y los próximos pasos para activar tu local.</p>
            </div>
          </div>
          <div className="ro-success-card-row">
            <span className="ro-success-card-ico">🛵</span>
            <div>
              <strong>¡Pronto en JAMA!</strong>
              <p>Una vez aprobado, tu negocio aparecerá en la app y podrás empezar a recibir pedidos.</p>
            </div>
          </div>
        </div>

        <a href="/" className="ro-success-home-btn" onClick={onReset}>
          Volver al inicio
        </a>

      </div>
    </div>
  );
};

export default StepRestaurantSuccess;
